import React from 'react';
import { Modal } from 'clad';

const GridForm = props => {
    const { form, onCancel, visible, record, loading, onRefresh } = props;

    const defaultTitle = {
        create: _('Create'),
        edit: _('Edit'),
        ...form.props.title
    };

    const title =
        (Object.keys(record).length === 0 && !loading) || record._duplicate
            ? defaultTitle.create
            : defaultTitle.edit;

    const gridForm = {
        ...form,
        props: {
            ...form.props,
            onCancel,
            record,
            loading,
            title: defaultTitle,
            onRefresh
        }
    };

    return (
        <Modal
            title={title}
            visible={visible}
            closable={false}
            centered
            footer={null}
        >
            {gridForm}
        </Modal>
    );
};

export default GridForm;
